import script from "./SkuUniquenessSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuUniquenessSetting.vue?vue&type=script&setup=true&lang=js"

import "./SkuUniquenessSetting.vue?vue&type=style&index=0&id=11a225b3&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a225b3"]])

export default __exports__